import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getMockEnabledShippingModes } from '@utils/mockUtils';
import urlList from '@utils/urlList';
import * as actions from '@redux-actions/';
import { handleHTTPError } from '@utils/utils';

/* SHIPPING */
export const getEnabledShippingModes = (mockRequests: boolean, hostname: string) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_SHIPPING_MODES'] + '?nocache=' + new Date().getTime();

        dispatch(getEnabledShippingModesRequest());
        return (mockRequests
            ? getMockEnabledShippingModes()
            : axios({
                url,
                method: 'GET',
                withCredentials: true
            })
        )
        .then((res: any) => {
            dispatch(getEnabledShippingModesSuccess(res.data))
        })
        .catch((err: any) => {
            console.error('>>> Get enabled shipping modes => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err.response); 
            dispatch(getEnabledShippingModesFailure());
        })
    }
}

const getEnabledShippingModesRequest = () => {
    return {
        type: actionTypes.GET_ENABLED_SHIPPING_MODES_REQUEST
    }
}

const getEnabledShippingModesSuccess = (data) => {
    return {
        type: actionTypes.GET_ENABLED_SHIPPING_MODES_SUCCESS,
        data
    }
}

const getEnabledShippingModesFailure = () => {
    return {
        type: actionTypes.GET_ENABLED_SHIPPING_MODES_FAILURE
    }
}

export const setSelectedShippingMode = (selectedShippingMode) => {
    return{
        type: actionTypes.SET_SELECTED_SHIPPING_MODE,
        selectedShippingMode
    }
}